<template>
  <button
      :class="computedClass"
      :type="type"
      :disabled="disabled"
      class="SmallButton font-size-small"
      @click="click"
  >
    <p class="label">
      <slot></slot>
    </p>
    <font-awesome-icon v-if="icon" :icon="icon"/>
  </button>
</template>

<script>
export default {
  name: 'SmallButton',
  props: {
    borderColor: {
      type: String,
      default: 'white',
    },
    color: {
      type: String,
      default: null,
    },
    icon: {
      default: null,
    },
    type: {
      type: String,
      default: 'button',
    },
    buttonHoverBehaviour: {
      type: String,
      default: 'null',
    },
    smaller: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    computedClass () {
      return {
        [`border-${this.borderColor}`]: true,
        [this.color]: true,
        hasIcon: this.icon != null,
        [`white-${this.buttonHoverBehaviour}-border`]: true,
        ['smaller']: this.smaller
      }
    },
  },
  methods: {
    click () {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import "@/assets/scss/bulma/projectBulma.scss";

.SmallButton {
  user-select: none;
  font-family: "Roboto", sans-serif;
  padding: 5px;
  min-width: 100px;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px $primary;
  color: $dark-text;
  font-weight: normal;
  outline: none;
  cursor: pointer;
  &:disabled {
    filter: grayscale(2);
    cursor: no-drop;
  }

  .label {
    padding: 0;
    margin: 0 !important;
    font-size: 1em;
    color: white;
    font-weight: 400;
  }

  svg {
    display: none;
    transition: 0.05s ease-out color;
  }

  &.border-white {
    border-color: $white;
  }

  &.border-primary {
    border-color: $primary;
  }

  &.border-danger {
    border-color: red;
  }

  &.primary {
    background-color: $primary;
  }

  &.deactivate {
    border-color: #777;
    cursor: default;
  }

  &.white-gold-border {
    border-color: $white;

    .label {
      color: white;
    }
  }

  &.white-gold-border:hover {
    border-color: $primary;

    .label {
      color: white;
    }
  }

  &.white-red-border {
    border-color: $white;

    .label {
      color: $dark-text;
    }
  }

  &.white-red-border:hover {
    border-color: red;

    .label {
      color: white;
    }
  }
}

// Mobile style
@media (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {
  .SmallButton.hasIcon {
    border: none;
    min-width: unset;
    font-size: 1.5em;

    .label {
      display: none;
    }

    svg {
      display: block;
      margin-left: auto;
      margin-right: 0;
    }

    &:hover {
      color: #aaa;
    }
  }
}

@media (max-width: $phone-max-width) {
  .SmallButton{
  
    .hasIcon {
      border: none;
      min-width: unset;
      font-size: 1.5em;

      .label {
        display: none;
      }

      svg {
        display: block;
        margin-left: auto;
        margin-right: 0;
      }

      &:hover {
        color: #aaa;
      }
    }

    &.smaller {
      min-width: 80px;
      margin-right: 0;
    }
  }
}
</style>
